<template>
    <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="登入頁面">
            <vue-editor
                    v-model="form.loginPage" style="font-size: initial;line-height: initial;"
            ></vue-editor>
        </el-form-item>
        <el-form-item label="抽籤規則">
            <vue-editor
                    v-model="form.drawRule" style="font-size: initial;line-height: initial;"
            ></vue-editor>
        </el-form-item>
        <el-form-item label="表單注意事項">
            <vue-editor
                    v-model="form.bookingWarning" style="font-size: initial;line-height: initial;"
            ></vue-editor>
        </el-form-item>
        <el-button @click="submit" :loading="loading.actions['setting']" type="primary">更新</el-button>
    </el-form>
</template>

<script>
    import {createNamespacedHelpers, mapState as mapRootState} from 'vuex';
    import { VueEditor } from "vue2-editor";

    const {mapState, mapActions} = createNamespacedHelpers('setting');
    const defaultForm = {
        loginPage:'',
        drawRule:'',
        bookingWarning:'',
    };
    export default {
        name: 'ViewContentSetting',
        components:{
            VueEditor
        },
        data: () => ({
            form: {...defaultForm},
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                ["clean"] // remove formatting button
            ]
        }),
        methods: {
            ...mapActions({
                getViewContent: 'getViewContentAction',
                updateViewContent: 'saveViewContentAction',
            }),
            async submit() {
                const {form} = this.$refs;
                form.validate(async (valid) => {
                    if (valid) {
                        const {success} = await this.updateViewContent({...this.form});
                        if(success){
                            this.$message({
                                type: 'success',
                                message: '異動成功'
                            });
                            form.clearValidate();
                        }

                    }
                });
            }
        },
        computed: {
            ...mapState(['viewContent']),
            ...mapRootState(['loading']),
        },
        watch: {
            viewContent(current) {
                const {
                    loginPage,
                    drawRule,
                    bookingWarning
                } = current;
                this.form.loginPage = loginPage;
                this.form.drawRule = drawRule;
                this.form.bookingWarning = bookingWarning;
            }
        },
        async created() {
            await this.getViewContent();
        }
    }
</script>

<style>

</style>